
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service_privacy_policy",
      function () {
        return require("private-next-pages/service_privacy_policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service_privacy_policy"])
      });
    }
  